//#region IMPORTS
import { EXCEL_EXPORT_PROMO_MODAL } from "../../models/_consts";
import { openModal } from "../../features/dashBoard/dashboardSlice";
import { useAppDispatch } from "../../store/configureStore";
import HomeExcelExportModalBody from "./HomeExcelExportModalBody";
import MainModal from "../_layout/MainModal";
//#endregion

// The orange "excel export" tile on the home page (admin). Used to hold an
// inline project dropdown + download button and fetched the promos on every
// home-page load; now the whole tile is one button that opens a modal where
// you pick a year first and then a project (HomeExcelExportModalBody).
export default function HomeInfoItemsExcelDownload() {
  //#region SETUP
  const dispatch = useAppDispatch();
  //#endregion

  //#region LOGIC
  const open = () => dispatch(openModal(EXCEL_EXPORT_PROMO_MODAL));
  const close = () => dispatch(openModal(false));
  //#endregion

  //#region RENDER
  return (
    <>
      <button
        type="button"
        onClick={open}
        className="self-stretch w-full rounded-lg p-4 flex items-center justify-center font-semibold text-white hover:bg-amber-600"
      >
        excel export
      </button>

      <MainModal type={EXCEL_EXPORT_PROMO_MODAL} closeHandler={close}>
        <HomeExcelExportModalBody closeHandler={close} />
      </MainModal>
    </>
  );
  //#endregion
}
